import React, { useEffect, useRef, useState } from "react";
import Board, {
  addCard,
  addColumn,
  moveCard,
  moveColumn,
  removeColumn,
  changeColumn,
} from "@asseinfo/react-kanban";
import "@asseinfo/react-kanban/dist/styles.css";
import { AiOutlinePlus } from "react-icons/ai";
import BoardCard from "../../components/BoardComponent/BoardCards";
import {
  useLocation,
  useParams,
  useSearchParams,
  useNavigate,
} from "react-router-dom";
import styles from "./ApplicantBoard.module.scss";
import { Button } from "react-bootstrap";
import { CiFilter } from "react-icons/ci";
import useModal from "../../components/Hooks/useModal";
import ModalDialog from "../../components/common/Modal/Modal";
import Form from "../../components/common/Form/From";
import Popover from "../../components/common/Popover/Popover";
import * as yup from "yup";
import {
  ApplicantActions,
  googleCalendarActions,
  jobProfileActions,
} from "../../actions";
import AddApplicantform from "../../components/Application/AddApplicantForm";
import ApplicantFilter from "../../components/ApplicantFilter/ApplicantFilter";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import Loader from "../../components/common/Loader/Loader";
import ConfirmDialog from "../../components/common/ConfirmDialog/ConfirmDialog";
import { BsExclamation, BsInfo } from "react-icons/bs";
import { isEmptyObject, updateURLParameter } from "../../helpers";
import { toast } from "react-toastify";
import { applicantProfileService } from "../../services";
import plusSVG from "../../assets/images/plus.svg";

import Select from "react-select";
import { Input, InputGroup, InputGroupText } from "reactstrap";
import { Search } from "react-bootstrap-icons";
import { Col, Row } from "reactstrap";
import Tabs from "../../components/HistoryComponents/Tabs";
import masterDataStyles from "../MasterData/MasterData.module.scss";
import { applicantConstants } from "../../constants";

const ApplicantBoardPage = () => {
  let boardRef = useRef(null);
  const navigate = useNavigate();
  const { toggle: addPositionToggle, visible: positionVisible } = useModal();
  const { toggle: ConfirmToggle, visible: confirmVisible } = useModal();
  const { toggle: ConfirmColumnToggle, visible: ConfirmColumnVisible } =
    useModal();
  const {
    toggle: ConfirmColumnInstarctionToggle,
    visible: ConfirmColumnInstarctionVisible,
  } = useModal();
  const [board, setBoard] = useState(null);
  const [loaderCheck, setLoaderCheck] = useState(false);
  const [activeColumn, setActiveColumn] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const paramLocation = searchParams.get("location");

  const [initialValues, setInitialValues] = useState({
    name: "",
    education: "",
    experienceYear: "",
    experienceMonth: "",
    relevantExperienceYear: "",
    relevantExperienceMonth: "",
    currentCTC: "",
    expectedCTC: "",
    noticePeriod: "",
    country: "IN",
    phone: "",
    email: "",
    location: searchParams.get("location") ? searchParams.get("location") : "",
    jobid: "",
    resume: "",
  });
  const [submited, setSubmited] = useState(false);
  const [channelPopover, setChannelPopover] = useState(false);
  const [editedData, setEditedData] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [activeData, setActiveData] = useState(null);
  const [filterData, setFilterData] = useState(null);
  const [isFilter, setIsFilter] = useState(false);
  const [appStatus, setAppStatus] = useState(null);
  const [showPart, setShowPart] = useState(false);
  const [appId, setAppId] = useState("");
  const [profileId, setprofileId] = useState("");
  const [jobId, setJobId] = useState("");
  const [options, setOptions] = useState([]);
  const dispatch = useDispatch();
  const SUPPORTED_FORMATS = ["application/pdf"];
  const location = useLocation();
  const { profileid } = useParams();
  const [filterText, setFilterText] = useState("");
  const [searchParm] = useSearchParams();
  const debounce = useRef();
  const debounceApi = useRef();
  function isFileSizeValid(file) {
    if (file) {
      return file?.size <= 1 * 1024 * 1000;
    } else {
      return true;
    }
  }
  const ApplicantSchema = yup.object().shape({
    jobid: yup.string().required("Job Profile is required"),
    name: yup.string().required("Name is required"),
    education: yup.string().required("Education is required"),
    expectedCTC: yup.number().required("Expected CTC is required"),
    phone: yup.number().required("Phone is required"),
    email: yup
      .string()
      .email("Please enter valid email address")
      .required("Email is required"),
    resume: yup
      .mixed()
      .nullable()
      .required("Resume is required")
      .test(
        "format",
        "Only the following formats are accepted: .pdf",
        (value) => !value || (value && SUPPORTED_FORMATS.includes(value.type))
      )
      .test("fileSize", "File size cannot exceed 1MB", (value) =>
        isFileSizeValid(value)
      ),
  });

  const ApplicantUpdateSchema = yup.object().shape({
    name: yup.string().required("Job profile is required"),
    education: yup.string().required("Education is required"),
    expectedCTC: yup.number().required("Expected CTC is required"),
    email: yup
      .string()
      .email("Please enter valid email address")
      .required("Email is required"),
    resume: yup
      .mixed()
      .test(
        "format",
        "Only the following formats are accepted: .pdf",
        (value) => !value || (value && SUPPORTED_FORMATS.includes(value.type))
      )
      .test("fileSize", "File size cannot exceed 1MB", (value) =>
        isFileSizeValid(value)
      ),
  });

  const boardData = useSelector((state) => state.applicant.boardData);
  const jobProfiles = useSelector((state) => state.jobProfiles.jobData);
  const jobProfilesSpecific = useSelector((state) => state.jobProfiles.jobData);
  const userRole = useSelector((state) => state.authentication.user.userRole);
  const jobStatus = location?.state?.jobStatus;
  const [activeTab, setActiveTab] = useState(
    searchParams.get("tab") === "applications"
  );
  useEffect(() => {
    let query = getRequestParams(filterData);
    if (query != undefined) {
      window.history.replaceState(
        "",
        "",
        updateURLParameter(window.location.href, new URLSearchParams(query))
      );
    }
  }, [activeTab]);

  useEffect(() => {
    if (jobProfiles && jobProfiles.length > 0) {
      if (appId == "") {
        let resVal = [];
        jobProfiles?.map((val) => {
          val.job_profile.map((job) => {
            resVal.push({
              value: job?.id,
              pId: val?.id,
              label: `${val.name} - ${job?.jobTitle}`,
            });
          });
        });
        setOptions(resVal);
      } else {
        if (jobProfilesSpecific?.length) {
          let resVal = [];
          jobProfilesSpecific?.map((val) => {
            val.job_profile.map((job) => {
              resVal.push({
                value: job?.id,
                pId: val?.id,
                label: `${val.name} - ${job?.jobTitle}`,
              });
            });
          });
          setOptions(resVal);
        }
      }
    }
  }, [jobProfiles]);

  useEffect(() => {
    if (userRole !== 4) {
      dispatch(jobProfileActions.getMasterData("designation"));
      dispatch(jobProfileActions.getAuthSearch());
    }
    dispatch(jobProfileActions.getjobIds());
    if (
      localStorage.getItem("jobProfile") &&
      localStorage.getItem("jobId") &&
      localStorage.getItem("applicantId")
    ) {
      searchParams.set("profileId", localStorage.getItem("jobProfile"));
      searchParams.set("jobId", localStorage.getItem("jobId"));
      setActiveTab(true);
      setSearchParams(searchParams);
    }

    if (searchParams.get("code")) {
      dispatch(
        googleCalendarActions.redirect({ code: searchParams.get("code") })
      ).then((res) => {
        if (res) {
          localStorage.setItem("google-token", true);
        }
      });
    }

    if (searchParams.get("profileId") && searchParams.get("jobId")) {
      setprofileId(searchParams.get("profileId"));
      setJobId(searchParams.get("jobId"));
      setShowPart(true);
      setLoaderCheck(true);
    } else {
      setShowPart(false);
    }
  }, []);

  useEffect(() => {
    if (boardData) {
      boardRef.current = boardData;
      setLoaderCheck(false);
      setBoard(boardData);
    }
  }, [boardData]);

  useEffect(() => {
    if (!searchParams.get("profileId") || !searchParams.get("jobId")) {
      setAppId("");
    }
  }, [searchParams.get("profileId"), searchParams.get("jobId")]);

  useEffect(() => {
    if (editedData !== null && editedData.id) {
      setInitialValues({
        name: editedData?.name,
        education: editedData?.education,
        experienceYear: editedData?.experienceYear,
        experienceMonth: editedData?.experienceMonth,
        relevantExperienceYear: editedData?.relevantExperienceYear,
        relevantExperienceMonth: editedData?.relevantExperienceMonth,
        currentCTC: editedData?.currentCTC,
        expectedCTC: editedData?.expectedCTC,
        noticePeriod: editedData?.noticePeriodValue,
        country: editedData?.country ? editedData?.country : "",
        phone: editedData?.phone,
        email: editedData?.email,
        location: editedData?.location,
        jobid: editedData?.jobid,
        resume: "",
        applicationStatus: editedData?.applicationStatus,
      });

      addPositionToggle();
    }
  }, [editedData]);

  useEffect(() => {
    clearTimeout(debounceApi.current);
    debounceApi.current = setTimeout(() => {
      if (jobId) {
        getBoardData();
      } else {
        setShowPart(false);
      }
    }, 300);
  }, [filterData, location, appId, filterText, jobId]);

  useEffect(() => {
    if (positionVisible === false) {
      if (!paramLocation) {
        resetVal();
      }
    }
    if (positionVisible) {
      dispatch(jobProfileActions.getCities("india"));
    }
  }, [positionVisible]);

  useEffect(() => {
    if (deleteId !== null) {
      ConfirmToggle();
    }
  }, [deleteId]);

  useEffect(() => {
    if (!loaderCheck) {
      const myBtn = document.getElementById(
        `BoardCard_${localStorage.getItem("applicantId")}`
      );
      myBtn?.click();
    }
  }, [loaderCheck]);

  function selectChnage(option) {
    if (option.label === "All Applicants") {
      setSearchParams("");
    }
    if (option.value !== "" && jobId !== option.value) {
      setLoaderCheck(true);
      setShowPart(true);
      setActiveTab(true);
    }
    navigate(
      `/applicants/${option.value}?profileId=${option.pId}&jobId=${option.value}&tab=applications`
    );
    setFilterText("");
    setprofileId(option?.pId);
    setJobId(option?.value);
  }

  const deleteApplicant = (id) => {
    if (id) {
      dispatch(ApplicantActions.deleteApplicant(deleteId)).then((res) => {
        if (res) {
          ConfirmToggle();
          if (!paramLocation) {
            resetVal();
          }
          let query = getRequestParams(filterData);
          dispatch(ApplicantActions.getBoardData(query));
        }
      });
    }
  };

  const resetVal = () => {
    setInitialValues({
      name: "",
      education: "",
      experienceYear: "",
      experienceMonth: "",
      relevantExperienceYear: "",
      relevantExperienceMonth: "",
      currentCTC: "",
      expectedCTC: "",
      noticePeriod: "",
      country: "IN",
      phone: "",
      email: "",
      location: "",
      jobid: "",
      resume: "",
    });
    setEditedData(null);
    setDeleteId(null);
    setActiveData(null);
    setActiveColumn(null);
  };

  const handleSubmit = (values) => {
    setSubmited(true);
    if (values) {
      if (editedData != null && editedData?.id) {
        dispatch(ApplicantActions.updateApplicant(values, editedData?.id)).then(
          (res) => {
            if (res) {
              setSubmited(false);
              dispatch(ApplicantActions.getApplicant(editedData?.id));
              if (!paramLocation) {
                resetVal();
              }
              getBoardData({ hideLoader: true });
              addPositionToggle();
            }
          }
        );
      } else {
        dispatch(ApplicantActions.createApplicant(values)).then((res) => {
          if (res) {
            setSubmited(false);
            if (!paramLocation) {
              resetVal();
            }
            getBoardData();
            addPositionToggle();
          }
        });
      }
    }
  };

  const hangleFilterOption = (data) => {
    if (!isEmptyObject(data)) {
      setFilterData(data);
      setIsFilter(true);
    } else {
      setFilterData(null);
      setIsFilter(false);
    }
  };

  const renderForm = (errors, touched) => {
    return (
      <AddApplicantform
        errors={errors}
        touched={touched}
        submited={submited}
        editedData={editedData}
      />
    );
  };
  const ColumnAdder = ({ addColumn }) => {
    return (
      <div
        className="addColumn-part"
        onClick={() => {
          if (board?.columns.length > 10) {
            toast.error("Max 10 column allow");
          } else {
            addColumn({
              id: board?.columns.length + 1,
              title: "Click to change title",
              isRejected: false,
              isSelected: false,
              cards: [],
            });
          }
        }}
      >
        <AiOutlinePlus />
      </div>
    );
  };

  const getRequestParams = (filterData) => {
    let params = {};
    if (profileId) {
      params["profileId"] = profileId;
    } else {
      if (searchParams.get("profileId")) {
        params["profileId"] = searchParams.get("profileId");
      }
    }
    if (jobId) {
      params["jobId"] = jobId;
    } else {
      if (searchParams.get("jobId")) {
        params["jobId"] = searchParams.get("jobId");
      }
    }

    if (searchParams.get("location")) {
      params["location"] = searchParams.get("location");
    }

    if (location?.state && location?.state?.applicationId) {
      params["applicationId"] = location?.state?.applicationId;
      params["tagged"] = location?.state?.tagged;
    }

    if (searchParams.get("applicationId")) {
      params["applicationId"] = searchParams.get("applicationId");
    }

    if (searchParams.get("tagged")) {
      params["tagged"] = searchParams.get("tagged");
    }

    if (searchParams.get("commentId")) {
      params["commentId"] = searchParams.get("commentId");
    }

    if (filterText) {
      params["name"] = filterText;
    }

    if (searchParams.get("applicationStatus")) {
      setAppStatus(searchParams.get("applicationStatus"));
      params["applicationStatus"] = searchParams.get("applicationStatus");
    }

    if (!isEmptyObject(filterData)) {
      params = { ...params, ...filterData };
    }

    if (jobId) {
      if (activeTab) {
        params["tab"] = "applications";
      } else {
        params["tab"] = "announcement";
      }
    }

    return params;
  };

  const getBoardData = async (values) => {
    let query = await getRequestParams(filterData);
    if (!values?.hideLoader) {
      setLoaderCheck(true);
    }
    dispatch(ApplicantActions.getBoardData(query)).then((res) => {
      if (res) {
        if (query != undefined) {
          window.history.replaceState(
            "",
            "",
            updateURLParameter(window.location.href, new URLSearchParams(query))
          );
        }
        setLoaderCheck(false);
      }
    });
  };

  const updateCardStatus = (board) => {
    if (board.columns.length > 0) {
      let finalArr = [];
      board.columns.forEach((val) => {
        finalArr.push({
          status: val?.title,
          isRejected: val.isRejected,
          isSelected: val.isSelected,
        });
      });
      if (finalArr.length > 0) {
        dispatch(
          ApplicantActions.updateStatus({ applicationStatus: finalArr })
        ).then((res) => {
          if (res) {
            if (!paramLocation) {
              resetVal();
            }
            getBoardData();
          }
        });
      }
    }
  };

  const updateCardStatusValue = (card, source, destination) => {
    if (board.columns.length > 0) {
      let finalArr = [];
      const columnBoard = moveColumn(board, source, destination);
      setBoard(columnBoard);
      columnBoard.columns.forEach((val) => {
        if (val?.title !== "Deleted Unassigned") {
          finalArr.push({
            status: val?.title,
            isRejected: val?.isRejected,
            isSelected: val?.isSelected,
            oldStatus: val?.title,
          });
        }
      });
      if (finalArr.length > 0) {
        dispatch(
          ApplicantActions.updateStatus({ applicationStatus: finalArr }, jobId)
        ).then((res) => {
          if (res) {
            if (!paramLocation) {
              resetVal();
            }
            getBoardData({ hideLoader: true });
          }
        });
      }
    }
  };

  useEffect(() => {
    if (activeData !== null) {
      dispatch(
        ApplicantActions.updateApplicant(
          { flagged: activeData?.flagged ? false : true },
          activeData?.id
        )
      ).then((res) => {
        if (res) {
          if (!paramLocation) {
            resetVal();
          }
          getBoardData({ hideLoader: true });
        }
      });
    }
  }, [activeData]);

  const updateCardNameValue = (boardDt, card) => {
    if (boardDt) {
      if (boardDt?.title) {
        let finalArr = [];
        board.columns.forEach((val) => {
          if (val?.id === boardDt?.id) {
            finalArr.push({
              status: card,
              isRejected: val.isRejected,
              isSelected: val.isSelected,
              oldStatus: boardDt?.title,
            });
          } else {
            if (val?.title !== "Deleted Unassigned") {
              finalArr.push({
                status: val?.title,
                isRejected: val?.isRejected,
                isSelected: val?.isSelected,
                oldStatus: val?.title,
              });
            }
          }
        });
        if (finalArr.length > 0) {
          dispatch(
            ApplicantActions.updateStatus(
              { applicationStatus: finalArr },
              jobId
            )
          ).then((res) => {
            if (res) {
              const rnameColumn = changeColumn(board, boardDt, {
                ...boardDt,
                title: card,
              });
              setBoard(rnameColumn);
              getBoardData();
            }
          });
        }
      }
    }
  };

  const updateCardName = (boardDt, card) => {
    if (boardDt.columns.length > 0) {
      const OldVal = board && board.columns.find((itm) => itm.id === card.id);
      if (OldVal) {
        let finalArr = [];
        boardDt.columns.forEach((val) => {
          if (val?.id === OldVal?.id) {
            finalArr.push({
              status: val?.title,
              isRejected: val.isRejected,
              isSelected: val.isSelected,
              oldStatus: OldVal?.title,
            });
          } else {
            finalArr.push({
              status: val?.title,
              isRejected: val.isRejected,
              isSelected: val.isSelected,
            });
          }
        });
        if (finalArr.length > 0) {
          dispatch(
            ApplicantActions.updateStatus({ applicationStatus: finalArr })
          ).then((res) => {
            if (res) {
              getBoardData();
            }
          });
        }
      }
    }
  };

  const OnStatusValueChange = async (card, source, destination) => {
    if (card) {
      setLoaderCheck(true);
      let applicationStatus = "";
      if (
        board?.columns &&
        board?.columns.length > 0 &&
        destination &&
        destination?.toColumnId >= 0
      ) {
        const findSt = board?.columns.find(
          (itm) => itm.id === destination?.toColumnId
        );
        applicationStatus = findSt?.title;
      }
      const updatedBoard = moveCard(board, source, destination);
      setBoard(updatedBoard);
      await applicantProfileService
        .updateStatus(
          {
            applicationStatus: applicationStatus,
            order: destination?.toPosition + 1,
          },
          card?.id
        )
        .then((res) => {
          if (res) {
            getBoardData({ hideLoader: true });
          }
        })
        .catch((e) => {});
    }
  };

  const NewColumnAdder = () => {
    return (
      <div className="add-button-container">
        <div
          className="addColumn-part"
          onClick={() => {
            if (board?.columns.length > 10) {
              toast.error("Max 10 column allow");
            } else {
              const newColumn = addColumn(board, {
                id: board?.columns.length + 1,
                title: "Click to change title",
                isRejected: false,
                isSelected: false,
                cards: [],
              });
              if (newColumn.columns.length > 0) {
                let finalArr = [];
                newColumn.columns.forEach((val) => {
                  if (
                    val?.isRejected === undefined &&
                    val?.isSelected === undefined
                  ) {
                    finalArr.push({
                      status: val?.title,
                      isRejected: false,
                      isSelected: false,
                    });
                  } else {
                    if (val?.title !== "Deleted Unassigned") {
                      finalArr.push({
                        status: val?.title,
                        isRejected: val?.isRejected,
                        isSelected: val?.isSelected,
                        oldStatus: val?.title,
                      });
                    }
                  }
                });
                if (finalArr.length > 0) {
                  dispatch(
                    ApplicantActions.updateStatus(
                      { applicationStatus: finalArr },
                      jobId
                    )
                  ).then((res) => {
                    if (res) {
                      if (!paramLocation) {
                        resetVal();
                      }
                      getBoardData();
                    }
                  });
                }
              }
            }
          }}
        >
          <img src={plusSVG} />
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (activeColumn !== null) {
      ConfirmColumnToggle();
    }
  }, [activeColumn]);

  useEffect(() => {
    if (ConfirmColumnVisible === false) {
      setActiveColumn(null);
    }
  }, [ConfirmColumnVisible]);

  const deleteColumn = (activeCol) => {
    if (activeCol) {
      const newCard = removeColumn(board, activeCol);
      if (newCard.columns.length > 0) {
        let finalArr = [];
        newCard.columns.forEach((val) => {
          if (val?.isRejected === undefined && val?.isSelected === undefined) {
            finalArr.push({
              status: val?.title,
              isRejected: false,
              isSelected: false,
            });
          } else {
            if (val?.title !== "Deleted Unassigned") {
              finalArr.push({
                status: val?.title,
                isRejected: val?.isRejected,
                isSelected: val?.isSelected,
                oldStatus: val?.title,
              });
            }
          }
        });
        if (finalArr.length > 0) {
          setBoard(newCard);
          dispatch(
            ApplicantActions.updateStatus(
              { applicationStatus: finalArr },
              jobId
            )
          ).then((res) => {
            if (res) {
              if (!paramLocation) {
                resetVal();
              }
              getBoardData();
              ConfirmColumnToggle();
            }
          });
        }
      }
    }
  };

  const onRemoveColumn = (_column) => {
    if (_column.cards && _column.cards.length === 0) {
      setActiveColumn(_column);
    } else {
      ConfirmColumnInstarctionToggle();
    }
  };

  function onColumnNew(board, newVal) {
    if (board.columns.length > 0) {
      let finalArr = [];
      board.columns.forEach((val) => {
        if (val?.isRejected === undefined && val?.isSelected === undefined) {
          finalArr.push({
            status: val?.title,
            isRejected: false,
            isSelected: false,
          });
        } else {
          finalArr.push({
            status: val?.title,
            isRejected: val?.isRejected,
            isSelected: val?.isSelected,
          });
        }
      });
      if (finalArr.length > 0) {
        dispatch(
          ApplicantActions.updateStatus({ applicationStatus: finalArr })
        ).then((res) => {
          if (res) {
            if (!paramLocation) {
              resetVal();
            }
            getBoardData();
          }
        });
      }
    }
  }

  const searchChange = (e) => {
    clearTimeout(debounce.current);
    debounce.current = setTimeout(() => {
      setFilterText(e?.target?.value);
    }, 400);
  };

  const Announcement = ({ jobId }) => {
    return (
      <>
        <Row>
          <Col md={12} sm={12}>
            <div className={styles.commentPart}>
              {jobId && <Tabs selectedId={jobId} announcementTab={true} />}
            </div>
          </Col>
        </Row>
      </>
    );
  };

  const announcementTab = () => {
    if (activeTab === true) {
      dispatch({
        type: applicantConstants.REMOVECOMMENTS,
      });
      setActiveTab(false);
    }
  };

  return (
    <div className={styles.ApplicantBoard}>
      <div className={styles.HeaderPart}>
        <div className="main-header-buttons">
          <div className={styles.buttonPart}>
            <>
              {userRole !== 4 ? (
                <Button
                  disabled={
                    !profileId ||
                    !jobId ||
                    jobStatus === "Closed" ||
                    board?.jobStatus === "Closed"
                  }
                  type="button"
                  onClick={() => addPositionToggle()}
                  className={styles.brandButton}
                >
                  <AiOutlinePlus /> Add Applicant
                </Button>
              ) : (
                ""
              )}
            </>

            <div className="selectMainPart">
              <Select
                options={options}
                name="selectJob"
                value={
                  options
                    ? options.find(
                        (option) => String(option.value) === String(jobId)
                      )
                    : ""
                }
                onChange={selectChnage}
                placeholder="Select Job"
                styles={{
                  menu: (provided) => ({
                    ...provided,
                    zIndex: 9999,
                    borderRadius: "0.5rem",
                  }),
                  option: (provided, state) => ({
                    ...provided,
                    backgroundColor: state.isSelected
                      ? "#CBD9EA"
                      : "transparent",
                    borderRadius: "0.3rem",
                    color: "black",
                  }),
                }}
              />
            </div>
          </div>
          {showPart && userRole !== 4 && (
            <div className="mt-2 mt-md-0">
              <InputGroup>
                <InputGroupText className="search-addon">
                  <Search />{" "}
                </InputGroupText>
                <Input
                  className="search-input"
                  placeholder="Search"
                  onChange={(e) => {
                    searchChange(e);
                  }}
                />
                <Button
                  type="button"
                  className={`btn ${
                    isFilter ? "filter-btn-active" : "filter-btn"
                  }`}
                  id="filter-button"
                >
                  <CiFilter />
                  Filter
                </Button>
              </InputGroup>

              <Popover
                popoverOpen={channelPopover}
                target="filter-button"
                handleToggle={() => {
                  setChannelPopover(!channelPopover);
                }}
                title={""}
                pbody={
                  <ApplicantFilter
                    hangleFilterOption={hangleFilterOption}
                    setChannelPopover={setChannelPopover}
                    filterData={filterData}
                    appStatus={appStatus}
                  />
                }
                classname="report-popover"
                placement="bottom-end"
              />
            </div>
          )}
        </div>
      </div>

      {showPart && userRole !== 4 && (
        <div className={`${masterDataStyles.MasterData} py-3 px-2`}>
          <div className={`${masterDataStyles.tabPart} p-0`}>
            <div className={masterDataStyles.tabButtonGroup}>
              <div
                className={`${masterDataStyles.commentPart} ${
                  activeTab ? masterDataStyles.active : ""
                }`}
                onClick={() => setActiveTab(true)}
              >
                Applications
              </div>
              <div
                className={`${masterDataStyles.historyPart} ${
                  !activeTab ? masterDataStyles.active : ""
                }`}
                onClick={() => announcementTab()}
              >
                Announcement
              </div>
            </div>
          </div>
        </div>
      )}

      {activeTab ? (
        <>
          {showPart ? (
            <div className={styles.KanbanBoad}>
              <div className={styles.applicantMain}>
                {loaderCheck ? (
                  <div className="d-flex h-75 justify-content-center h-90vh">
                    {" "}
                    <Loader color={"#5382ba"} />{" "}
                  </div>
                ) : (
                  <BoardPart
                    board={board}
                    updateCardStatus={updateCardStatusValue}
                    OnStatusChange={OnStatusValueChange}
                    onColumnNew={onColumnNew}
                    onRemoveColumn={onRemoveColumn}
                    updateCardName={updateCardNameValue}
                    setDeleteId={setDeleteId}
                    setActiveData={setActiveData}
                    setEditedData={setEditedData}
                    getBoardData={getBoardData}
                    NewColumnAdder={NewColumnAdder}
                  />
                )}
              </div>
            </div>
          ) : (
            <div className={styles.emptyBoard}>
              <p>
                Welcome to ATS, Kindly choose a Job to see the list of
                applicants
              </p>
            </div>
          )}
        </>
      ) : (
        showPart && <Announcement jobId={jobId} />
      )}

      {!showPart && (
        <div className={styles.emptyBoard}>
          <p>
            Welcome to ATS, Kindly choose a Job to see the list of applicants
          </p>
        </div>
      )}

      <ModalDialog
        toggle={addPositionToggle}
        title={`${editedData != null ? "Update" : "Add"} Applicant`}
        visible={positionVisible}
        size="md"
        bodyClass="p-0"
      >
        <Form
          initialValues={initialValues}
          validationSchema={
            editedData != null ? ApplicantUpdateSchema : ApplicantSchema
          }
          handleSubmit={handleSubmit}
          renderForm={renderForm}
        />
      </ModalDialog>
      <ConfirmDialog
        visible={confirmVisible}
        toggle={ConfirmToggle}
        title="Are you sure you want to delete the Applicant?"
        activeBtnClick={() => {
          deleteApplicant(deleteId);
        }}
      >
        <div className={`confirmIcon rounded-circle`}>
          <BsExclamation style={{ fontSize: 42 }} />
        </div>
      </ConfirmDialog>
      <ConfirmDialog
        visible={confirmVisible}
        toggle={ConfirmToggle}
        title="Are you sure you want to delete the Applicant?"
        activeBtnClick={() => {
          deleteApplicant(deleteId);
        }}
      >
        <div className={`confirmIcon rounded-circle`}>
          <BsExclamation style={{ fontSize: 42 }} />
        </div>
      </ConfirmDialog>

      <ConfirmDialog
        visible={ConfirmColumnVisible}
        toggle={ConfirmColumnToggle}
        title="Are you sure you want to delete?"
        activeBtnClick={() => {
          deleteColumn(activeColumn);
        }}
      >
        <div className={`confirmIcon rounded-circle`}>
          <BsExclamation style={{ fontSize: 42 }} />
        </div>
      </ConfirmDialog>

      <ConfirmDialog
        visible={ConfirmColumnInstarctionVisible}
        toggle={ConfirmColumnInstarctionToggle}
        title="Please move all the cards to any other column and then try deleting"
        type="info"
        activeBtnClick={() => {
          ConfirmColumnInstarctionToggle();
        }}
      >
        <div className={`confirmIcon rounded-circle`}>
          <BsInfo style={{ fontSize: 42 }} />
        </div>
      </ConfirmDialog>
    </div>
  );
};

const BoardPart = (props) => {
  const [editingColumnId, setEditingColumnId] = useState(null);
  const [newColumnTitle, setNewColumnTitle] = useState("");

  const handleColumnEdit = (columnId) => {
    setEditingColumnId(columnId);
    const column = props.board.columns.find((col) => col.id === columnId);
    setNewColumnTitle(column.title);
  };

  const handleRenameSave = (column, card) => {
    props?.updateCardName(column, card);
    setEditingColumnId(null);
  };

  const handleCancelEdit = () => {
    setEditingColumnId(null);
  };

  const user = useSelector((state) => state.authentication.user);
  return user && user?.userRole !== 4 ? (
    <>
      <Board
        allowRenameColumn
        allowRemoveColumn
        onCardRemove={console.log}
        onLaneRename={console.log}
        allowAddColumn
        onColumnDragEnd={(board, source, destination) =>
          props?.updateCardStatus(board, source, destination)
        }
        onCardDragEnd={(card, source, destination) =>
          props?.OnStatusChange(card, source, destination)
        }
        onColumnNew={(columnBag, newVal) =>
          props?.onColumnNew(columnBag, newVal)
        }
        renderColumnAdder={() => <props.NewColumnAdder />}
        renderCard={(data, { removeCard, dragging }) => (
          <div className={styles.kanbanCard}>
            <BoardCard
              dragging={dragging}
              data={data}
              removeCard={removeCard}
              setDeleteId={props?.setDeleteId}
              setActiveData={props?.setActiveData}
              setEditedData={props?.setEditedData}
              getBoardData={props?.getBoardData}
            />
          </div>
        )}
        onColumnRename={(board, card) => props?.updateCardName(board, card)}
        changeColumn={console.log}
        onColumnRemove={(columnBag, newVal) => props?.onRemoveColumn(columnBag)}
        renderColumnHeader={(column) => (
          <>
            <div className="customKanbanHeader">
              {editingColumnId === column.id ? (
                <div className="d-flex justify-content-between">
                  <input
                    type="text"
                    value={newColumnTitle}
                    onChange={(e) => setNewColumnTitle(e.target.value)}
                    autoFocus
                    className="formInput"
                  />
                  <button
                    className="btn btn-rename"
                    onClick={() => {
                      handleRenameSave(column, newColumnTitle);
                    }}
                  >
                    Rename
                  </button>
                  <button
                    className="btn btn-cancel-edit"
                    onClick={handleCancelEdit}
                  >
                    Cancel
                  </button>
                </div>
              ) : (
                <div className="d-flex justify-content-between align-content-center">
                  <h6
                    className="customTitleTxt m-0"
                    onClick={() => handleColumnEdit(column.id)}
                  >
                    {column.title}
                    {column.cards.length > 0 && (
                      <>
                        <span>({column.cards.length})</span>
                      </>
                    )}
                  </h6>
                  <span
                    onClick={() => props?.onRemoveColumn(column)}
                    className="customCloseIcon"
                  >
                    ×
                  </span>
                </div>
              )}
            </div>
          </>
        )}
      >
        {props?.board}
      </Board>
    </>
  ) : (
    <Board
      disableCardDrag
      disableColumnDrag
      onCardDragEnd={(card, source, destination) =>
        props?.OnStatusChange(card, source, destination)
      }
      renderCard={(data, { removeCard, dragging }) => (
        <div className={styles.kanbanCard}>
          <BoardCard
            dragging={dragging}
            data={data}
            removeCard={removeCard}
            setDeleteId={props?.setDeleteId}
            setActiveData={props?.setActiveData}
            setEditedData={props?.setEditedData}
            getBoardData={props?.getBoardData}
          />
        </div>
      )}
    >
      {props?.board}
    </Board>
  );
};

export default ApplicantBoardPage;
